import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./components/Pages/Home/Home";
import ContactUs from "./components/Pages/ContactUs/ContactUs";
import SchoolProgram from "./components/Pages/SchoolProgram/SchoolProgram";
import AboutUs from "./components/Pages/AboutUs/AboutUs";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer/Footer";
import Pricing from "./components/Pages/Pricing/Pricing";
import { APP_PATH } from "./components/constant";
import InstitutRules from "./components/Pages/InstitutRules/InstitutRules";
import Loader from "./components/GeneralComponents/Loader/Loader";
import { useEffect, useState } from "react";
import ScrollToTop from "./components/GeneralComponents/ScrollTop/ScrollTop";
import SubscribeForm from "./components/Pages/Subscribe/Subscribe";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div style={{ height: "100px" }} />
      <Routes>
        <Route path={APP_PATH.HOME} element={<Home />} />
        {/* <Route path={APP_PATH.REGISTRATION} element={<Registration />} /> */}
        {/* <Route path={APP_PATH.LOGIN} element={<Login />} /> */}
        <Route path={APP_PATH.ABOUT} element={<AboutUs />} />
        <Route path={APP_PATH.CONTACT} element={<ContactUs />} />
        <Route path={APP_PATH.PROGRAM} element={<SchoolProgram />} />
        <Route path={APP_PATH.PRICING} element={<Pricing />} />
        <Route path={APP_PATH.RULES} element={<InstitutRules />} />
        <Route path={APP_PATH.SUBSCRIBE} element={<SubscribeForm />} />
        <Route
          path={APP_PATH.UNKNOWN}
          element={<Navigate to={APP_PATH.HOME} replace />}
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
